<payarc-dialog-shell title="Contact" (closed)="dialogRef.close(false)">
  <form #updateCustomerDetail="ngForm">
    <payarc-form-field label="Notification contact number" controlId="phone"
      [error]="updateCustomerDetail.submitted && phoneInp.invalid ? (phoneInp.errors?.required ? 'Phone number is required.' : 'Phone number is invalid.') : ''">
      <div class="ucd-phone-row">
        <span class="ucd-phone-prefix">+1</span>
        <input class="pa-input" id="phone" name="phone" #phoneInp="ngModel"
               placeholder="(000) 000-0000" required pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
               [(ngModel)]="phone" type="tel" appPhoneMask maxlength="14" autocomplete="off"
               [class.invalid]="updateCustomerDetail.submitted && phoneInp.invalid">
      </div>
    </payarc-form-field>
  </form>

  <div footer class="ucd-footer">
    <button type="button" payarcButton="secondary" (click)="dialogRef.close(false)">Cancel</button>
    <app-loading-button (buttonClick)="onUpdateClick(updateCustomerDetail)"
                         [loadFlag]="loadFlag" [buttonText]="'Update'"></app-loading-button>
  </div>
</payarc-dialog-shell>
